export default "__VITE_ASSET__7dEqfzJF__"